import {ReactNode} from "react";
import {EncounterRuntimeProvider} from "@/encounter/EncounterRuntimeProvider.tsx";
import EncounterReadyGate from "@/encounter/EncounterReadyGate.tsx";
import InitialLoadBoundary from "@/components/loading/InitialLoadBoundary.tsx";

export default function TableTopRuntimeBoundary({encounterId, children, onReady, onError}: {
    encounterId?: string;
    children: ReactNode;
    onReady?: () => void;
    onError?: () => void;
}) {
    return <InitialLoadBoundary key={encounterId} onReady={onReady} onError={onError}>
        <EncounterRuntimeProvider encounterId={encounterId}>
            <EncounterReadyGate>{children}</EncounterReadyGate>
        </EncounterRuntimeProvider>
    </InitialLoadBoundary>;
}
